export const canUseMockBilling = ({ enabled, demo = false, user }) => {
  return Boolean(enabled && !demo && user?.is_admin);
};
